import { Text } from '@wartek-id/text'

import { Container } from '@/components/Container'
import { RoundedTable } from '@/components/RoundedTable/RoundedTable'

import { CustomMetadataCellRenderer } from './CustomMetadataCellRenderer'
import { STANDARD_DATA_ITEMS_PTK } from '../data/standard-data-ptk'
import { STANDARD_DATA_ITEMS } from '../data/standard-data-satpen-yayasan'

const STANDARD_DATA_COLUMNS = [
  {
    id: 'number',
    displayName: 'No',
  },
  {
    id: 'concept',
    displayName: 'Konsep',
  },
  {
    id: 'definition',
    displayName: 'Definisi',
  },
  {
    id: 'classification',
    displayName: 'Klasifikasi',
  },
  {
    id: 'unit',
    displayName: 'Unit',
  },
  {
    id: 'values',
    displayName: 'Ukuran',
  },
]

const STANDARD_DATA_COLUMNS_PTK = [
  {
    id: 'number',
    displayName: 'No',
  },
  {
    id: 'name',
    displayName: 'Nama Data',
  },
  {
    id: 'concept',
    displayName: 'Konsep',
  },
  {
    id: 'definition',
    displayName: 'Definisi',
  },
  {
    id: 'classification',
    displayName: 'Klasifikasi',
    childColumns: [
      {
        id: 'penyajian',
        displayName: 'Penyajian',
      },
      {
        id: 'isian',
        displayName: 'Isian',
      },
    ],
  },
  {
    id: 'ukuran',
    displayName: 'Ukuran',
  },
  {
    id: 'unit',
    displayName: 'Satuan',
  },
]

const SUBHEADING = {
  'satpen-yayasan':
    'Standar data yang terkait dengan Satuan Pendidikan PAUD DIKDASMEN',
  ptk: 'Standar data yang terkait dengan Pendidik dan Tenaga Kependidikan',
}

export const StandardDataPanel = ({ jenis }: { jenis: string }) => {
  return (
    <Container className="mt-6">
      <Text variant="subheading" className="mb-6 uppercase">
        {SUBHEADING[jenis]}
      </Text>
      <RoundedTable
        columns={
          jenis === 'satpen-yayasan'
            ? STANDARD_DATA_COLUMNS
            : STANDARD_DATA_COLUMNS_PTK
        }
        // @ts-ignore
        data={
          jenis === 'satpen-yayasan'
            ? STANDARD_DATA_ITEMS
            : STANDARD_DATA_ITEMS_PTK
        }
        withSummary={false}
        CustomCellRenderer={({ row, col }) => {
          return <CustomMetadataCellRenderer row={row} col={col} />
        }}
      />
    </Container>
  )
}
